var map = {
	"./photo01.webp": 998,
	"./photo02.webp": 999,
	"./photo03.webp": 1000,
	"./photo04.webp": 1001,
	"./photo05.webp": 1002,
	"./photo06.webp": 1003,
	"./photo07.webp": 1004,
	"./photo08.webp": 1005,
	"./photo09.webp": 1006,
	"./photo10.webp": 1007,
	"./photo11.webp": 1008,
	"./photo12.webp": 1009
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 997;